export { GlobalStateProvider } from "~/components/GlobalState/GlobalStateProvider";

export {
  useRegisterAccountModal,
  useGlobalModals,
} from "~/components/GlobalState/globalStateHooks";
